import { numericExtent, hmaSeries } from "../utils";
const HMA = {
    name: "HMA",
    compute: (bars, period = 9) => hmaSeries(bars.map((b) => b.close), period),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default HMA;
